window['__Zone_disable_requestAnimationFrame'] = true; // disable patch requestAnimationFrame
